module.exports = __webpack_public_path__ + "static/media/IMG_20180808_202438.415a1c5c.jpg";